export default __webpack_public_path__ + "static/media/mobile-commerce-effect-sales.b87b3389.jpg";